import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import Cookies from "universal-cookie";

import Navbar from "../components/Navbar"

export default function AwaitingApproval({ data }) {
    const cookies = new Cookies();
    const token = cookies.get("TOKEN");
    const navigate = useNavigate();

    useEffect(() => {
      // If token and userData are present, navigate to the map page
      if (token && data && data.status === "Active") {
        navigate("/auth/map");
      }
    }, [token, data, navigate]);

    /**  LOGOUT FUNCTION  **/
    const logout = () => {
      cookies.remove("TOKEN", { path: '/' });
      localStorage.clear();
      navigate("/");
    };
  
    return (
      <div>
        <Navbar/>
        <h1 style={{marginTop: "30px", marginLeft: "30px"}}>Awaiting Approval</h1>
        <p style={{marginLeft: "30px"}}>Please wait for approval from a system administator.</p>
        <Button
          style={{marginLeft: "30px"}}
          onClick={logout}
          to="/">
          Logout
        </Button>
      </div>
    );
}